module.exports = __webpack_public_path__ + "img/lens-160-plus-06.006dbcea.png";